/** Formency logomark — three interlocking brackets, rendered in brand gradient. */
export default function Logomark({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 7.74048V24.2594C30 27.962 27.0275 30.9049 23.2877 30.9049H12.0685C12.0685 27.962 14.4658 25.5885 17.4384 25.5885H23.2877C24.0548 25.5885 24.6301 25.0189 24.6301 24.2594V13.0569C24.6301 10.1139 27.0275 7.74048 30 7.74048Z"
        fill="url(#logo-a)"
      />
      <path
        d="M20.1233 13.3418C20.1233 16.2848 17.7261 18.6582 14.7534 18.6582H13.1233C10.0548 18.6582 7.46577 21.1266 7.36988 24.1646V25.6836C7.36988 28.6265 4.97261 31.0001 2 31.0001V24.5444C2 18.3734 7.08221 13.3418 13.3151 13.3418H20.1233Z"
        fill="url(#logo-b)"
      />
      <path
        d="M25.9726 1C25.9726 3.94303 23.5754 6.31644 20.6028 6.31644H8.80824C8.2329 6.31644 7.36988 7.17087 7.36988 7.74049V9.54428C7.36988 12.4873 4.97261 14.8607 2 14.8607V7.74049C2 4.03797 5.0685 1 8.80824 1H25.9726Z"
        fill="url(#logo-c)"
      />
      <defs>
        <linearGradient
          id="logo-a"
          x1="12.0685"
          y1="7.74048"
          x2="34.4938"
          y2="25.0997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9B4A" />
          <stop offset="0.55" stopColor="#FF6EB1" />
          <stop offset="1" stopColor="#8A6CF0" />
        </linearGradient>
        <linearGradient
          id="logo-b"
          x1="2"
          y1="13.3418"
          x2="19.6523"
          y2="31.459"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9B4A" />
          <stop offset="0.55" stopColor="#FF6EB1" />
          <stop offset="1" stopColor="#8A6CF0" />
        </linearGradient>
        <linearGradient
          id="logo-c"
          x1="2"
          y1="1"
          x2="14.0125"
          y2="21.7759"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9B4A" />
          <stop offset="0.55" stopColor="#FF6EB1" />
          <stop offset="1" stopColor="#8A6CF0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
